import {Component, Inject, OnInit} from '@angular/core';
import {CompetitionWz} from "../../../shared/interface/competition-wz";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

export interface WarehouseProductListDialogData {
  competitionWz?: CompetitionWz;
}

@Component({
  selector: 'app-warehouse-product-list',
  templateUrl: './warehouse-product-list.component.html',
  styleUrls: ['./warehouse-product-list.component.scss']
})
export class WarehouseProductListComponent implements OnInit {
  competitionWzObject?: CompetitionWz = null;


  constructor(
    public dialogRef: MatDialogRef<WarehouseProductListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: WarehouseProductListDialogData
  ) {
    this.competitionWzObject = data.competitionWz;
  }

  ngOnInit(): void {
  }

}
